import { Button, Stack, TextField, Typography } from '@mui/material';
import HeadingWithDescription from '../../components/headingWithDescription';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { SendSharp } from '@mui/icons-material';
import moment from 'moment';
import { IoMdCall } from 'react-icons/io';

function BaseMessage({
  message,
  alignSelf,
  sender,
  imageUrl,
}: {
  message: string;
  alignSelf: 'flex-end' | 'flex-start';
  sender: 'user' | 'technician';
  imageUrl?: string;
}) {
  return (
    <Stack
      flexDirection={'row'}
      sx={{ maxWidth: '80%', alignSelf, alignItems: 'center', gap: 0.5 }}
    >
      <Stack sx={{ p: 1.5, bgcolor: '#FFF', borderRadius: 3, flex: 1 }}>
        <Typography sx={{ textTransform: 'capitalize', alignSelf }} variant="caption">
          {sender}
        </Typography>
        <Typography>{message}</Typography>
        <Typography alignSelf={alignSelf} fontSize={11} color="textDisabled" variant="caption">
          {moment().fromNow()}
        </Typography>
      </Stack>
    </Stack>
  );
}

function UserMessage({ message }: { message: string }) {
  return <BaseMessage message={message} alignSelf="flex-end" sender="user" />;
}

function TechnicianMessage({ message, profilePic }: { message: string; profilePic: string }) {
  return (
    <BaseMessage
      message={message}
      alignSelf="flex-start"
      sender="technician"
      imageUrl={profilePic}
    />
  );
}

export default function ChatWithTechnician() {
  const [searchParams] = useSearchParams();
  const ticketNumber = searchParams.get('id');
  const navigate = useNavigate();

  if (!ticketNumber) return <Navigate to="/track-status" />;
  const imageUrl =
    'https://img.freepik.com/free-photo/portrait-young-handsome-contractor-going-through-home-inspection-white-background_662251-3008.jpg?semt=ais_hybrid&w=740';

  return (
    <div className="flex flex-col container mx-auto flex-1">
      <Stack p={2} flex={1} gap={1}>
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} gap={1}>
          <HeadingWithDescription heading="Chat with Technician" description={''} />
          <Stack flexDirection={'row'} alignItems={'center'}>
            <Button>
              <IoMdCall fontSize={25} />
            </Button>
            {imageUrl && (
              <img
                alt="technician-img"
                src={imageUrl}
                style={{
                  height: 40,
                  width: 40,
                  borderRadius: 50,
                  objectFit: 'cover',
                  borderWidth: 2,
                }}
              />
            )}
          </Stack>
        </Stack>
        {/* Chat Window */}
        <Stack flex={1} bgcolor={'#F5F5F5'}>
          <Stack
            sx={{
              p: 1,
              py: 2,
              overflowY: 'scroll',
              overflowX: 'hidden',
              height: '81vh',
              minHeight: '81vh',
              maxHeight: '81vh',
              scrollbarWidth: 'none',
              gap: 1,
            }}
          >
            <TechnicianMessage message="Hi, I am Rishabh. How can I help you ?" profilePic="" />
            <UserMessage message="Hi, My machine is not working properly." />
          </Stack>
        </Stack>
        {/* Chat Input */}
        <Stack direction={'row'} gap={1}>
          <TextField label="Message" style={{ flex: 1 }} />
          <Button variant="text" onClick={() => navigate('/track-status')}>
            <SendSharp />
          </Button>
        </Stack>
      </Stack>
    </div>
  );
}
